import {FileConstant} from '@shared/constants/common.constant';

export class CommonUtils {
  public static getCookieValue(cookieName) {
    let cookieRegex = new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    let match = document.cookie.match(cookieRegex);
    return match ? decodeURIComponent(match[1]) : null;
  }

  public static getModalSize(window: any) {
    return window.innerWidth > 767 ? window.innerWidth / 1.5 > 800 ? 800 : window.innerWidth / 1.5 : window.innerWidth;
  }

  public static serialize(obj = {}) {
    const arr = [];
    for (const k of Object.keys(obj)) {
      arr.push(
        `${k}=${encodeURIComponent(
          typeof obj[k] === 'string'
            ? String.prototype.trim.call(obj[k])
            : obj[k] === null
            ? ''
            : obj[k]
        )}`
      );
    }
    return arr.join('&');
  }

  public static delEmptyKey(obj: {}) {
    const objCpy = {};
    if (obj === null || obj === undefined || obj === '') {
      return objCpy;
    }
    for (const key in obj) {
      if (obj[key] !== null && typeof obj[key] === 'object') {
        objCpy[key] = this.delEmptyKey(obj[key]);
      } else if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
        objCpy[key] = obj[key];
      }
    }
    return objCpy;
  }

  public static isEmptyObject(obj: {}) {
    let name: any;
    // tslint:disable-next-line: forin
    for (name in obj) {
      return false;
    }
    return true;
  }

  public static isValidDate(date: Date) {
    return date instanceof Date && !isNaN(date.getTime());
  }

  public static obj2Str(obj: any) {
    const p = {};
    for (const key of Object.keys(obj)) {
      if (obj[key] || obj[key] === 0) {
        if (obj[key].toString() !== '') {
          p[key] = obj[key].toString();
        }
      }
    }
    return p;
  }

  public static str2arr(str: string) {
    return str.replace(/[\r\n\s]/g, '').split(',');
  }

  public static getScrollbarWidth() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.cssText =
      'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  }

  public static getTypeExportUlti(format: string): string {
    let type: string;
    switch (format) {
      case FileConstant.EXCEL_TYPE_1:
        type = FileConstant.EXCEL_MIME_1;
        break;
      case FileConstant.EXCEL_TYPE_2:
        type = FileConstant.EXCEL_MIME_2;
        break;
      case FileConstant.PDF_TYPE:
        type = FileConstant.PDF_MIME;
        break;
      case FileConstant.DOC_TYPE:
        type = FileConstant.DOC_MIME;
        break;
      case FileConstant.DOCX_TYPE:
        type = FileConstant.DOCX_MIME;
        break;
      default:
        type = null;
        break;
    }
    return type;
  }

  public static convertToType(typevar, input) {
    return {
      'string': String.bind(null, input),
      'number': Number.bind(null, input)
    }[typeof typevar]();
  }

  public static checkFileExtension(fileName: string, ...fileExtensions) {
    if (!!fileName) {
      return fileExtensions.some((item) => fileName.toLowerCase().endsWith(item.toLowerCase()));
    }
  }

  public static getFileNameExport(name: string) {
    const today = new Date();
    const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
    const month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1;
    const hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
    const minutes = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
    const seconds = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds();
    return `${name}_${day}${month}${today.getFullYear()}_${hours}${minutes}${seconds}`;
  }
  public static formatVNDWithoutUnit(value: number, locale: string = 'vi-VN'): string {
    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 0, // No fractional units
      maximumFractionDigits: 0,
    }).format(value);
  }
}
